import {
    Box,
    Center,
    Text,
    Button,
    VStack,
} from '@chakra-ui/react';
import React, { useState, useEffect } from "react";
import { useParams, Link } from 'react-router-dom';
import { HorizontalBar, Pagination, PaginationButton } from "./style";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import APIConfig from "../../../api/APIConfig";
import ReactLoading from "react-loading";


function MenteeManajemen() {
    const [lowongan, setLowongan] = useState([]);
    const [spinner, setSpinner] = useState(false); 

    const { id } = useParams();

    let data = lowongan;

    console.log("test :" + data.length);

    const getProposal = async(idMentor) => {  
        setSpinner(true);
        const response = await APIConfig.get(`/v1/mentor/list-mentee/${idMentor}`);
        const result = await response.data;
        setLowongan(result);
        setSpinner(false);

    };
    
    useEffect(() => {
        getProposal(id);
    }, []);

    const [currentPage, setCurrentPage] = useState(1);
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(data.length / 10); i++) {
        pageNumbers.push(i);
    }

    const indexOfLastData = currentPage * 10;
    const indexOfFirstData = indexOfLastData - 10;
    data = data.slice(indexOfFirstData, indexOfLastData);

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
      }


    return(
        <div className="container">
        <Center py={6}>
        <VStack align='stretch' fontFamily={'Inter'} pb={20}>
            <Text
                pt={3}
                pb={6}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}>
               Mentee Management
            </Text>
            
            <Box
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                alignContent={'center'}
                rounded={'2xl'}
                p={2}
                overflow={'hidden'}>
                <VStack align='center'>
                    {lowongan.length > 0 ? 
                        <Table style={{width: '95%', margin: '20px 0'}}>
                            <Thead className="head">
                            <Tr>
                                <Th className='layout'><p className='layoutp'>Id</p></Th>
                                <Th className='layout'><p className='layoutp'>Nama</p></Th>
                                <Th className='layout'><p className='layoutp'>Email</p></Th>
                                <Th className='layout'><p className='layoutp'>Nama Kegiatan</p></Th>
                                <Th className='layout'><p className='layoutp'>Posisi</p></Th>
                                <Th className='layout'><p className='layoutp'>Lihat Laporan</p></Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {data.map((data)=>
                                    <Tr>
                                    <Td className='layout'><p className='layoutp'>{data.idPeserta}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.namaPeserta}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.emailPeserta}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.namaProposal}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.posisi}</p></Td>
                                    <Td>       
                                        <Link to={`/mentor/manajemenmentee/listlaporanpeserta/${id}/${data.idLowonganPeserta}`} style={{textDecoration: 'none'}}>
                                        <Button 
                                            size='xs' rounded={'xl'} background='#6554C0' color='#FFFFFF' variant='solid' fontSize={'xs'} margin={'0 10px'}>
                                            Lihat Laporan
                                        </Button>
                                        </Link>
                                    </Td>
                                </Tr>
                                )}
  
                            </Tbody>
                        </Table>
                    : 
                    <Text fontSize={"large"} fontWeight={'600'}>Belum ada peserta yang mentee yang terdaftar</Text>
                    }
                    {data.length > 0 ? (<HorizontalBar last={true} />) : null}
                                {pageNumbers.length > 1 && (
                                    <Pagination
                                    style={{margin: 'auto'}}>
                                        <PaginationButton onClick={() => 
                                            setCurrentPage(1)}>
                                            &lt;&lt;
                                        </PaginationButton>
                                        <PaginationButton onClick={() => 
                                            currentPage === 1 ? setCurrentPage(1) : setCurrentPage(currentPage-1)}>
                                            &lt;
                                        </PaginationButton>
                                        {pageNumbers.map((page) => (
                                            <PaginationButton
                                                unshow={
                                                    currentPage > 2 && pageNumbers.length - currentPage > 1
                                                    ? Math.abs(currentPage - page) > 2
                                                    : pageNumbers.length - currentPage < 2
                                                    ? pageNumbers.length - page > 4
                                                    : page > 5
                                                }
                                                active={currentPage === page}
                                                onClick={() => setCurrentPage(page)}
                                                >
                                                    {page}
                                            </PaginationButton>
                                        ))}
                                        <PaginationButton
                                            onClick={() =>
                                            currentPage === pageNumbers.length
                                                ? setCurrentPage(pageNumbers.length)
                                                : setCurrentPage(currentPage + 1)
                                            }
                                        >
                                            &gt;
                                        </PaginationButton>
                                        <PaginationButton onClick={() => setCurrentPage(pageNumbers.length)}>
                                            &gt;&gt;
                                        </PaginationButton>
                                    </Pagination>
                                )}
                </VStack>
            </Box>
            </VStack>
            </Center>
        </div>   
    );
}

export default MenteeManajemen;